import { render } from "./LoadingRing.vue?vue&type=template&id=491ad586&scoped=true"
import script from "./LoadingRing.vue?vue&type=script&lang=js"
export * from "./LoadingRing.vue?vue&type=script&lang=js"

import "./LoadingRing.vue?vue&type=style&index=0&id=491ad586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491ad586"]])

export default __exports__